export const global = {
  // Development
  // base_url: "https://mcd-backend.test",

  // UAT
  // base_url: "http://192.168.100.19",
  
  // Production
  base_url: "https://mcdonalds.com.bn",

  get url() {
    return this.base_url + "/api";
  },

  get app_version() {
    return "2.1.0";
  },
};

